module.exports = __webpack_public_path__ + "static/media/manufacturer2.93131153.png";